/*
 * This file is auto-generated. Do not modify it manually!
 */
import React from 'react';

import clsx from '@proton/utils/clsx';

import { MIME_ICON_VIEWBOX, type MimeIconComponentProps, getMimeIconAsset } from '../component';

export const MimeAlbum = ({ alt, title, size = 4, className, ...rest }: MimeIconComponentProps) => {
    const asset = getMimeIconAsset(size);

    return (
        <>
            <svg
                role="img"
                viewBox={MIME_ICON_VIEWBOX[asset]}
                focusable="false"
                className={clsx(`icon-size-${size}`, className)}
                {...rest}
            >
                {title ? <title>{title}</title> : null}
                {asset === 'sm' && (
                    <g>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16 13.6V4.5C16 3.7268 15.403 3.1 14.6667 3.1H8.75556C8.40936 3.1 8.07251 2.9821 7.79556 2.764L5.91111 1.28C5.68032 1.09825 5.39961 1 5.11111 1H1.33333C0.596954 1 0 1.6268 0 2.4V13.6C0 14.3732 0.596954 15 1.33333 15H14.6667C15.403 15 16 14.3732 16 13.6Z"
                            fill="#F5A623"
                        ></path>
                        <path
                            d="M8.91128 13.007C9.25527 13.007 9.45427 12.6311 9.25244 12.3627L6.88888 9.21874C6.78795 9.08449 6.58041 9.08449 6.47949 9.21874L4.76065 11.5051L3.80498 10.2339C3.70405 10.0996 3.49651 10.0996 3.39559 10.2339L1.79518 12.3627C1.59335 12.6311 1.79235 13.007 2.13634 13.007H8.91128Z"
                            fill="#C56708"
                        ></path>
                        <path
                            d="M5.14435 8.34029C5.14435 8.76984 4.80323 9.11807 4.38244 9.11807C3.96165 9.11807 3.62054 8.76984 3.62054 8.34029C3.62054 7.91073 3.96165 7.5625 4.38244 7.5625C4.80323 7.5625 5.14435 7.91073 5.14435 8.34029Z"
                            fill="#C56708"
                        ></path>
                    </g>
                )}
                {asset === 'md' && (
                    <g>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M24.01 20.9V7.25C24.01 6.0902 23.1142 5.15 22.0092 5.15H13.1388C12.6193 5.15 12.1138 4.97315 11.6982 4.646L8.87036 2.42C8.52402 2.14737 8.10278 2 7.66986 2H2.00083C0.895804 2 0 2.9402 0 4.1V20.9C0 22.0598 0.895804 23 2.00083 23H22.0092C23.1142 23 24.01 22.0598 24.01 20.9Z"
                            fill="#F5A623"
                        ></path>
                        <path
                            d="M13.3725 20.0105C13.8887 20.0105 14.1873 19.4467 13.8844 19.044L10.3376 14.3281C10.1862 14.1267 9.87472 14.1267 9.72328 14.3281L7.14395 17.7576L5.70984 15.8508C5.55839 15.6494 5.24695 15.6494 5.0955 15.8508L2.69389 19.044C2.39102 19.4467 2.68965 20.0105 3.20584 20.0105H13.3725Z"
                            fill="#C56708"
                        ></path>
                        <path
                            d="M7.71973 13.0104C7.71973 13.6548 7.20785 14.1771 6.5764 14.1771C5.94495 14.1771 5.43307 13.6548 5.43307 13.0104C5.43307 12.3661 5.94495 11.8438 6.5764 11.8438C7.20785 11.8438 7.71973 12.3661 7.71973 13.0104Z"
                            fill="#C56708"
                        ></path>
                    </g>
                )}
                {asset === 'lg' && (
                    <g>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M47.9167 40.9V14.25C47.9167 11.9856 46.1321 10.15 43.9306 10.15H26.2588C25.2239 10.15 24.2168 9.80472 23.3888 9.166L17.7551 4.82C17.0652 4.28773 16.2259 4 15.3635 4H4.06948C1.86802 4 0.083374 5.83563 0.083374 8.1V40.9C0.083374 43.1644 1.86802 45 4.06948 45H43.9306C46.1321 45 47.9167 43.1644 47.9167 40.9Z"
                            fill="#F5A623"
                        ></path>
                        <path
                            d="M26.7244 39.1633C27.7528 39.1633 28.3477 38.0626 27.7443 37.2764L20.6782 28.0692C20.3765 27.676 19.756 27.676 19.4543 28.0692L14.3157 34.7649L11.4587 31.042C11.1569 30.6489 10.5365 30.6489 10.2348 31.042L5.45021 37.2764C4.84682 38.0626 5.44176 39.1633 6.47013 39.1633H26.7244Z"
                            fill="#C56708"
                        ></path>
                        <path
                            d="M15.4628 25.4965C15.4628 26.7545 14.443 27.7743 13.185 27.7743C11.9271 27.7743 10.9073 26.7545 10.9073 25.4965C10.9073 24.2386 11.9271 23.2188 13.185 23.2188C14.443 23.2188 15.4628 24.2386 15.4628 25.4965Z"
                            fill="#C56708"
                        ></path>
                    </g>
                )}
            </svg>
            {alt ? <span className="sr-only">{alt}</span> : null}
        </>
    );
};
